<template>
	<div style="padding: 16px; box-sizing: border-box;">
		<!-- 顶部标签栏与操作区 -->
		<div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
			<el-tabs v-model="activeName" @tab-click="handleTabClick" style="flex: 1;">
				<el-tab-pane :label="$t('能源.加油登记')" name="addoil"></el-tab-pane>
				<el-tab-pane :label="$t('能源.充电登记')" name="charging"></el-tab-pane>
				<el-tab-pane :label="$t('能源.加氢登记')" name="hydrogen"></el-tab-pane>
			</el-tabs>
			<div style="display: flex; align-items: center;">
				<el-form class="search-form" :inline="true" size="mini" style="flex: 1">
					<el-form-item :label="$t('vehicle.carNo')+':'" style="font-size: 12px;">
						<el-input class="search-key-input" v-model="searchKey" clearable
							:placeholder="$t('maintenancemanagement.inputcarNo')"></el-input>
					</el-form-item>
					<el-form-item>
						<span style="font-size: 12px;">{{$t("time.timeQuery")}}</span>
						<el-date-picker v-model="dateRange" type="daterange" size="mini"
							:range-separator="$t('time.to')" value-format="yyyy-MM-dd"
							:start-placeholder="$t('time.startTimeHolder')" :end-placeholder="$t('time.endTimeHolder')"
							clearable style="width:265px" />
					</el-form-item>
					<el-form-item>
						<el-button style="margin-left: 30px;" type="primary" size="small"
							@click="handleQuery">{{$t('public.query')}}</el-button>
						<el-button type="success" style="margin-left: 20px;" size="small" @click="handleAdd">
						{{ $t('public.add')}}
					</el-button>
					<el-button type="primary" style="margin-left: 20px;" size="small" @click="onExportClick">
						{{ $t('public.export')}}
					</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>

		<!-- 新增/修改弹窗 -->
		<el-dialog :title="getAddButtonText()" :visible.sync="addDialogVisible" width="780px">
			<el-divider></el-divider>
			<div style="font-size: 14px;margin: 20px 20px;font-weight: 500;">
				{{ getAddButtonTitle() }}
			</div>

			<el-form label-width="140px" ref="formRef" :model="formData" :rules="formRules">
				<div style="display: flex; align-items: center; justify-content: center; ">
					<div>
						<!-- 车辆（必填） -->
						<el-form-item :label="$t('maintenancemanagement.carNo') " prop="CarNo"
							style="margin-top: 10px;">
							<el-select style="width: 100%;" filterable v-model="formData.CarNo"
								:placeholder="$t('public.select')" :disabled="isEditMode">
								<el-option v-for="item in vehicles.data" v-if="item.treeLevel == 5&& 
          item.oilTypeID_New !== undefined &&  
       matchOilType(item.oilTypeID_New) " :key="item.nodeValue" :label="item.vehicleName" :value="item.nodeValue">
								</el-option>
							</el-select>
						</el-form-item>

						<!-- 费用（必填，标签带单位） -->
						<el-form-item :label="getCostLabel() " prop="OilMoney">
							<el-input v-model.number="formData.OilMoney" :placeholder="$t('路费.请输入费用')"></el-input>
						</el-form-item>

						<!-- 单价（必填，标签带单位） -->
						<el-form-item :label="getPriceLabel() " prop="OilPrice">
							<el-input v-model.number="formData.OilPrice"
								:placeholder="$t('maintenancemanagement.inputunitPrice')"></el-input>
						</el-form-item>
					</div>

					<div style="margin-right: 40px;">
						<!-- 日期（必填） -->
						<el-form-item :label="$t('public.date')+':'" prop="OilTime">
							<el-date-picker v-model="formData.OilTime" :picker-options="pickerOptions"
								format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
								:placeholder="$t('vehicleInfo.selectusedate')" />
						</el-form-item>

						<!-- 数量（必填，标签带单位） -->
						<el-form-item :label="getVolumeLabel() " prop="OilNum">
							<el-input v-model.number="formData.OilNum"
								:placeholder="$t('maintenancemanagement.inputquantity')"></el-input>
						</el-form-item>

						<!-- 站点名称 -->
						<el-form-item :label="getStationLabel()">
							<el-input v-model="formData.OilStation" :placeholder="$t('能源.请输入站点名称')"></el-input>
						</el-form-item>
					</div>
				</div>

				<div style="margin-right:40px;margin-left: -15px;">
					<el-form-item :label="$t('路费.备注信息')+':'">
						<el-input type="textarea" v-model="formData.Memo" :placeholder="$t('路费.请输入备注信息')"></el-input>
					</el-form-item>

					<el-form-item :label="$t('路费.备注图片')+':'">
						<el-upload list-type="picture-card" :on-preview="handlePictureCardPreview"
							:action="uploadAction" :on-remove="handleRemove" :file-list="formData.images"
							:on-error="handleUploadError" :on-success="handleUploadSuccess" class="small-upload"
							:headers="uploadHeaders" :data="{ path: 'app' }" :before-upload="beforeUpload" name="name"
							:limit="3" :on-exceed="handleExceed">
							<i class="el-icon-plus"></i>
						</el-upload>
						<el-dialog :visible.sync="dialogVisible">
							<img width="100%" :src="dialogImageUrl" :alt="$t('路费.预览图片')">
						</el-dialog>
					</el-form-item>
				</div>

				<div style="text-align: right;">
					<el-form-item>
						<el-button @click="addDialogVisible = false">{{$t('public.cancel')}}</el-button>
						<el-button type="primary" @click="handleFormSubmit"
							:loading="submitLoading">{{$t('public.save')}}</el-button>
					</el-form-item>
				</div>
			</el-form>
		</el-dialog>
		<!-- 数据表格 -->
		<el-table :data="tableData" border style="width: 100%" max-height="500" v-loading="loading">
			<el-table-column align="center" type="index" :label="$t('public.index')" width="80" />
			<el-table-column align="center" prop="CarNo" :label="$t('行程统计.车牌号')" />
			<!-- OilTime列仅显示年月日 -->
			<el-table-column align="center" prop="OilTime" :label="$t('能源.操作日期')" :formatter="formatYmdDate" />

			<!-- 加油相关列 -->
			<template v-if="activeName === 'addoil'">
				<el-table-column align="center" prop="OilMoney" :label="$t('能源.加油费用')" />
				<el-table-column align="center" prop="OilNum" :label="$t('能源.加油量')" />
				<el-table-column align="center" prop="OilPrice" :label="$t('能源.加油单价')" />
				<el-table-column align="center" prop="OilStation" :label="$t('能源.加油站名称')" />
			</template>

			<!-- 充电相关列 -->
			<template v-if="activeName === 'charging'">
				<el-table-column align="center" prop="OilMoney" :label="$t('能源.充电费用')" />
				<el-table-column align="center" prop="OilNum" :label="$t('能源.充电量')" />
				<el-table-column align="center" prop="OilPrice" :label="$t('能源.充电单价')" />
				<el-table-column align="center" prop="OilStation" :label="$t('能源.充电站名称')" />
			</template>

			<!-- 加氢相关列 -->
			<template v-if="activeName === 'hydrogen'">
				<el-table-column align="center" prop="OilMoney" :label="$t('能源.加氢费用')" />
				<el-table-column align="center" prop="OilNum" :label="$t('能源.加氢气量')" />
				<el-table-column align="center" prop="OilPrice" :label="$t('能源.加氢单价')" />
				<el-table-column align="center" prop="OilStation" :label="$t('能源.加氢站名称')" />
			</template>

			<el-table-column align="center" prop="operator" :label="$t('能源.操作人员')" />
			<el-table-column align="center" prop="Memo" :label="$t('路费.备注信息')" />
			<el-table-column align="center" prop="RemarkImage" :label="$t('路费.备注图片')" min-width="120">
				<template #default="scope">
					<!-- 处理多图片逻辑 -->
					<div v-if="scope.row.RemarkImage && scope.row.RemarkImage.trim()">
						<div class="image-group">
							<!-- 循环显示所有图片 -->
							<el-image v-for="(path, index) in getImageList(scope.row.RemarkImage)" :key="index"
								:src="getImageUrl(path)" :preview-src-list="getAllImageUrls(scope.row.RemarkImage)"
								style="width: 40px; height: 40px; cursor: pointer; margin-right: 5px;" fit="cover"
								:alt="$t('路费.备注图片')">
								<!-- 图片加载失败时显示 -->
								<!-- 			<template #error>
									<div
										style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background: #f5f5f5;">
										<i class="el-icon-picture-outline" style="color: #ccc;"></i>
									</div>
								</template> -->
							</el-image>
						</div>
					</div>
					<!-- 无图片时显示默认图标 -->
					<!-- <div v-else
						style="width: 40px; height: 40px; background: #f5f5f5; display: flex; align-items: center; justify-content: center;">
						<i class="el-icon-picture-outline" style="color: #ccc;"></i>
					</div> -->
				</template>
			</el-table-column>
			<!-- 操作列 -->
			<el-table-column align="center" :label="$t('public.Operation')" width="140">
				<template #default="scope">
					<el-button size="mini" type="primary"
						@click="handleEdit(scope.row)">{{$t('public.edit')}}</el-button>
					<el-button size="mini" type="danger"
						@click="handleDelete(scope.row.OilID)">{{$t('public.del')}}</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页组件 -->
		<div style="margin-top: 15px; text-align: right;">
			<div style="text-align: right; margin-top:8px" class="pagination" v-show="total>0">
					<kl-pagination :total="total" :currentPage="currentPage" @current-change="handleCurrentChange"
						@size-change="sizeChange" :pageSize="pageSize"></kl-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import language from '@/utils/getLanguageId';
	import settings from "@/settings";
	import * as XLSX from 'xlsx'
 
	export default {
		name: "energyRegistration",
		data() {
			return {
				activeName: 'addoil',
				loading: false,
				searchKey: "", // 车牌号查询条件
				dateRange: [
					this.moment().subtract(6, 'days').format('YYYY-MM-DD'), // 默认最近一周（今天-6天）
					this.moment().format('YYYY-MM-DD')
				],
				total: 0, // 数据总条数
				currentPage: 1, // 当前页码
				pageSize: 10, // 每页条数
				tableData: [], // 表格数据
				addDialogVisible: false, // 弹窗显示状态
				submitLoading: false, // 提交按钮加载状态
				dialogImageUrl: '', // 图片预览地址
				dialogVisible: false, // 图片预览弹窗状态

				// 表单数据
				formData: {
					OilID: '', // 记录ID
					CarNo: '', // 车牌号
					OilTime: '', // 操作日期
					OilMoney: '', // 费用
					OilPrice: '', // 单价
					OilNum: '', // 数量
					OilStation: '', // 站点名称
					Memo: '', // 备注信息
					images: [] // 上传图片列表（存储{url: 正式地址, name: 文件名}）
				},

				// 表单验证规则（车辆、日期、费用、量、单价设为必填）
				formRules: {
					CarNo: [{
						required: true,
						message: this.$t("路费.请选择车牌号"),
						trigger: 'change'
					}],
					OilTime: [{
						required: true,
						message: this.$t('vehicleInfo.selectusedate'),
						trigger: 'change'
					}],
					OilMoney: [{
							required: true,
							message: this.$t("路费.请输入费用"),
							trigger: 'blur'
						},
						{
							type: 'number',
							message: this.$t("路费.请输入有效的数字"),
							trigger: 'blur'
						}
					],
					OilPrice: [{
							required: true,
							message: '请输入单价',
							trigger: 'blur'
						},
						{
							type: 'number',
							message: this.$t("路费.请输入有效的数字"),
							trigger: 'blur'
						}
					],
					OilNum: [{
							required: true,
							message: this.$t("maintenancemanagement.inputquantity"),
							trigger: 'blur'
						},
						{
							type: 'number',
							message: this.$t("路费.请输入有效的数字"),
							trigger: 'blur'
						}
					]
				},
				oilTypeMatchRule: {
					addoil: [1, 3], // 加油：匹配oilTypeID_New=1、3
					charging: [3, 4, 5], // 充电：匹配oilTypeID_New=3、4、5
					hydrogen: [2, 4] // 加氢：匹配oilTypeID_New=2、4
				},

				// 日期选择器配置
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},
				isEditMode: false,
				LanguageId: 1,
				// 图片上传基础路径（根据后端实际地址配置）
				imageBaseUrl: '/api/upload/', // 示例：后端存储图片的基础URL
				uploadHeaders: {
					Token: '' // 后续赋值token
				}
			}
		},

		computed: {
			size() {
				return this.$store.getters.size
			},
			uploadAction() {
				return settings.baseUrl + 'automatic/v1/uploadFile';
			},
			...mapState({
				operator: state => state.user.operator, // 操作人员信息
				vehicles: state => state.app.vehicles, // 车辆列表数据
				token: state => state.user.token
			}),
		},

		mounted() {
			this.$store.dispatch("app/closeSideBar");
			this.LanguageId = language(this.$store.getters.locale)
			this.uploadHeaders.Token = this.token;
			this.getTableData(); // 初始化加载表格数据
			console.log(this.vehicles.data)
		},
		destroyed() {
			this.$store.dispatch("app/openSideBar");
		},
		methods: {
			// 超过上传数量限制时的回调
			handleExceed(files, fileList) {
				this.$message.warning(`最多只能上传3张图片`);
			},
			matchOilType(oilTypeID) {
				// 1. 获取当前标签页对应的油类型数组（如addoil对应[1,3]）
				const targetOilTypes = this.oilTypeMatchRule[this.activeName];
				// 2. 转换为数字（防止后端返回字符串类型）
				const oilTypeNum = Number(oilTypeID);
				// 3. 判断是否在目标数组中（支持多油类型匹配）
				return targetOilTypes.includes(oilTypeNum);
			},

			// 日期格式化函数：仅保留年月日
			formatYmdDate(row, column) {
				const oilTime = row.OilTime;
				if (!oilTime) return '';
				// 处理ISO格式(T分隔)和常规格式(空格分隔)
				return oilTime.split('T')[0].split(' ')[0];
			},
			beforeUpload(file) {
				console.log("选择的图片原始文件名：", file.name);
				console.log("图片格式：", file.type);
				console.log("图片大小：", file.size + " bytes");

				// 检查图片格式
				const isImage = file.type.startsWith('image/');
				if (!isImage) {
					this.$message.error('只能上传图片文件！');
					return false;
				}

				// 检查图片大小（限制5MB以内）
				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isLt5M) {
					this.$message.error('图片大小不能超过5MB！');
					return false;
				}

				return true;
			},
			// 上传成功回调
			handleUploadSuccess(response, file, fileList) {
				if (response.code === "Success" && response.FileName) {
					// 处理后端返回的文件名，去除"longyi/"前缀
					let fileName = response.FileName.replace(/^longyi\//, '');
					// let fileName = response.FileName;

					// 更新文件列表，保存后端返回的文件名
					this.formData.images = fileList.map(item => ({
						...item,
						name: fileName, // 保存后端返回的文件名
						url: this.getImageUrl(fileName) // 构建图片预览地址
					}));

					// this.$message.success(this.$t('路费.图片上传成功'));
				} else {
					this.$message.error(response.message || this.$t('路费.图片上传失败'));
				}
			},
			// 获取按钮文本
			getAddButtonText() {
				const prefix = this.isEditMode ? this.$t('public.edit') : this.$t('public.add');
				switch (this.activeName) {
					case 'addoil':
						return this.isEditMode ? this.$t('能源.编辑加油登记') : this.$t('能源.新增加油登记');
					case 'charging':
						return this.isEditMode ? this.$t('能源.编辑充电登记') : this.$t('能源.新增充电登记');
					case 'hydrogen':
						return this.isEditMode ? this.$t('能源.编辑加氢登记') : this.$t('能源.新增加氢登记');
					default:
						return this.$t('能源.新增登记');
				}
			},

			// 获取标题文本
			getAddButtonTitle() {
				switch (this.activeName) {
					case 'addoil':
						return this.$t('能源.加油信息');
					case 'charging':
						return this.$t('能源.充电信息');
					case 'hydrogen':
						return this.$t('能源.加氢信息');
					default:
						return "";
				}
			},

			// 获取带单位的费用标签
			getCostLabel() {
				switch (this.activeName) {
					case 'addoil':
						return this.$t('能源.加油费用') + ':';
					case 'charging':
						return this.$t('能源.充电费用') + ':';
					case 'hydrogen':
						return this.$t('能源.加氢费用') + ':';
					default:
						return this.$t('能源.费用') + ':';
				}
			},

			// 获取带单位的数量标签
			getVolumeLabel() {
				switch (this.activeName) {
					case 'addoil':
						return this.$t('能源.加油量') + ':';
					case 'charging':
						return this.$t('能源.充电量') + ':';
					case 'hydrogen':
						return this.$t('能源.加氢气量') + ':';
					default:
						return this.$t('maintenancemanagement.quantity') + ':';
				}
			},

			// 获取带单位的单价标签
			getPriceLabel() {
				switch (this.activeName) {
					case 'addoil':
						return this.$t('能源.加油单价') + ':';
					case 'charging':
						return this.$t('能源.充电单价') + ':';
					case 'hydrogen':
						return this.$t('能源.加氢单价') + ':';
					default:
						return this.$t('maintenancemanagement.unitPrice') + ':';
				}
			},

			// 获取站点标签
			getStationLabel() {
				switch (this.activeName) {
					case 'addoil':
						return this.$t('能源.加油站名称') + ':';
					case 'charging':
						return this.$t('能源.充电站名称') + ':';
					case 'hydrogen':
						return this.$t('能源.加氢站名称') + ':';
					default:
						return this.$t('能源.站点名称') + ':';
				}
			},

			// 获取操作类型
			getOilType() {
				switch (this.activeName) {
					case 'addoil':
						return 3; // 加油
					case 'charging':
						return 1; // 充电
					case 'hydrogen':
						return 7; // 加氢
					default:
						return 3;
				}
			},

			// 新增按钮点击事件
			handleAdd() {
				this.addDialogVisible = true;
				this.isEditMode = false; // 新增时禁用标记设为false
				this.$nextTick(() => {
					this.resetForm();
				});
			},

			// 重置表单
			resetForm() {
				this.formData = {
					OilID: '',
					CarNo: '',
					OilTime: '',
					OilMoney: '',
					OilPrice: '',
					OilNum: '',
					OilStation: '',
					Memo: '',
					images: []
				};
				if (this.$refs.formRef) {
					this.$refs.formRef.resetFields();
				}
				this.dialogImageUrl = '';
				this.dialogVisible = false;
			},

			// 修改按钮点击事件
			handleEdit(row) {
				// 字段映射
				const fieldMap = {
					addoil: {
						OilMoney: 'OilMoney',
						OilNum: 'OilNum',
						OilPrice: 'OilPrice',
						OilStation: 'OilStation'
					},
					charging: {
						OilMoney: 'OilMoney',
						OilNum: 'OilNum',
						OilPrice: 'OilPrice',
						OilStation: 'OilStation'
					},
					hydrogen: {
						OilMoney: 'OilMoney',
						OilNum: 'OilNum',
						OilPrice: 'OilPrice',
						OilStation: 'OilStation'
					}
				} [this.activeName];

				// 图片回显
				const images = row.RemarkImage ?
					row.RemarkImage.split(',').map(fileName => ({
						url: this.getImageUrl(fileName),
						name: fileName
					})) : [];

				let targetVehicle = null;
				if (this.vehicles.data && this.vehicles.data.length) {
					targetVehicle = this.vehicles.data.find(item =>
						item.treeLevel === 5 && // 仅筛选车辆级数据
						item.vehicleName === row.CarNo // 按车牌号匹配（不筛选油类型）
					);
				}
				// 填充表单数据（原逻辑不变）
				this.formData = {
					OilID: row.OilID,
					CarNo: targetVehicle ? targetVehicle.nodeValue : '', // 回显车辆ID（确保下拉框显示正确名称）
					OilTime: this.formatYmdDate(row, null),
					OilMoney: row[fieldMap.OilMoney],
					OilNum: row[fieldMap.OilNum],
					OilPrice: row[fieldMap.OilPrice],
					OilStation: row[fieldMap.OilStation],
					Memo: row.Memo || '',
					images: images
				};

				// 核心：设置为「修改模式」，禁用车辆下拉
				this.isEditMode = true;
				this.addDialogVisible = true;
			},

			// 3. 重置表单：清空修改模式标记（避免影响下次新增）
			resetForm() {
				this.formData = {
					OilID: '',
					CarNo: '',
					OilTime: '',
					OilMoney: '',
					OilPrice: '',
					OilNum: '',
					OilStation: '',
					Memo: '',
					images: []
				};
				this.isEditMode = false; // 重置为新增模式
				if (this.$refs.formRef) {
					this.$refs.formRef.resetFields();
				}
				this.dialogImageUrl = '';
				this.dialogVisible = false;
			},

			// 删除按钮点击事件
			handleDelete(oilId) {
				this.$confirm(this.$t('路费.确定要删除这条记录吗'), this.$t('public.tips'), {
					type: 'warning'
				}).then(() => {
					this.$api.saveOilInfoNew({
						operate: 3, // 3表示删除
						OilID: oilId
					}).then(res => {
						if (res.code === 200) {
							this.$message.success(this.$t('public.hasDeleted'));
							this.getTableData();
						} else {
							this.$message.error(this.$t('public.DeleteFail') + ':' + (res.message || ''));
						}
					}).catch(err => {
						this.$message.error(this.$t('路费.接口请求失败'));
						console.error(err);
					});
				});
			},
			handleFormSubmit() {
				this.$refs.formRef.validate(async (valid) => {
					if (!valid) {
						this.$message.warning(this.$t('路费.表单填写有误'));
						return;
					}
					try {
						this.submitLoading = true;
						const isEdit = !!this.formData.OilID;

						// 验证图片数据并处理文件名（确保移除longy）
						const validImages = this.formData.images.filter(img =>
							img && img.name && typeof img.name === 'string'
						);

						// 提取图片name数组并移除"longy"字符串（双重保障）
						const remarkImages = validImages.map(img => {
							let processedName = img.name;
							// 移除所有"longy"字符串（全局替换）
							if (typeof processedName === 'string') {
								processedName = processedName.replace(/longy/g, '');
							}
							return processedName;
						});
						// 验证核心数据
						if (!this.formData.CarNo) throw new Error(this.$t('recharge.请选择车辆'));
						if (!this.formData.OilTime) throw new Error(this.$t('vehicleInfo.selectusedate'));
						if (this.formData.OilMoney === '' || this.formData.OilMoney <= 0) throw new Error(
							this.$t('路费.请输入有效的费用'));
						let newvehicle = this.vehicles.data.filter((item) => item.treeLevel == 5);
						console.log(newvehicle)
						newvehicle.forEach(item => {
							if (item.vehicleName == this.formData.CarNo) {
								this.formData.CarNo = item.nodeValue;
							}
						});
						const params = {
							operate: isEdit ? 2 : 1, // 1新增 2修改
							OilID: this.formData.OilID || '',
							V_ID: this.formData.CarNo,
							OilTime: this.formData.OilTime,
							OilNum: this.multiplyBy100(this.formData.OilNum).toString(), // 数量乘以100
							OilPrice: this.multiplyBy100(this.formData.OilPrice).toString(), // 单价乘以100
							OilMoney: this.multiplyBy100(this.formData.OilMoney).toString(), // 费用乘以100
							OilType: this.getOilType(),
							PeopleName: "",
							OilStation: this.formData.OilStation,
							EntryName: this.operator,
							EntryTime: new Date().toISOString().slice(0, 19).replace('T', ' '),
							Memo: this.formData.Memo,
							RemarkImage: remarkImages.join(',') // 最终提交处理后的文件名
						};

						const res = await this.$api.saveOilInfoNew(params);

						if (res.code === 200) {
							this.$message.success(isEdit ? this.$t('public.edit_success') : this.$t(
								'路费.新增成功'));
							this.addDialogVisible = false;
							this.getTableData();
						} else {
							throw new Error(res.message || (isEdit ? this.$t('changepsw.change_fail') : this
								.$t('路费.新增成功')));
						}
					} catch (err) {
						console.error(this.$t('路费.表单提交失败'), err);
						this.$message.error(this.$t('路费.操作失败') + ':' + err.message);
					} finally {
						this.submitLoading = false;
					}
				});
			},
			multiplyBy100(value) {
				// 转换为数字，空值或非数字默认返回0
				const num = value === '' || value === null ? 0 : Number(value);
				// 处理NaN情况
				if (isNaN(num)) return 0;
				// 乘以100并四舍五入保留2位小数（避免浮点数精度问题）
				return Math.round(num * 100 * 100) / 100;
			},
			// 图片预览
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			// 1. 将逗号分隔的图片路径字符串转为数组
			getImageList(remarkImageStr) {
				if (!remarkImageStr || typeof remarkImageStr !== 'string') {
					return [];
				}
				// 分割字符串并过滤空值
				return remarkImageStr.split(',').filter(path => path.trim());
			},

			// 2. 生成所有图片的完整URL（用于预览）
			getAllImageUrls(remarkImageStr) {
				const imageList = this.getImageList(remarkImageStr);
				return imageList.map(path => this.getImageUrl(path));
			},

			// 移除图片
			handleRemove(file, fileList) {
				this.formData.images = fileList;
			},

			// 自定义上传方法（核心：替换默认上传，正确构建FormData）
			async customUpload(options) {
				const file = options.file; // 选中的文件对象
				console.log(options)

				// 1. 构建FormData
				const formData = new FormData();
				const nativeFile = file instanceof Blob ? file : file.raw;

				// 验证文件对象类型
				if (!(nativeFile instanceof Blob)) {
					throw new Error(this.$t('路费.上传的文件不是有效的Blob类型'));
				}
				// 正确添加文件到FormData
				formData.append('name', nativeFile, file.name || 'unknown-file');
				formData.append('path', 'app');
				// 2. 调用上传接口（使用项目已有的api.uploadFile）
				this.$api.uploadFile(formData).then(res => {
					// 3. 处理上传成功（后端返回FileName，拼接正式URL）
					if (res.code === "Success" && res.FileName) {
						let fileName = res.FileName;
						if (fileName && typeof fileName === 'string') {
							// 全局替换所有"longyi"字符串（不区分大小写可改为 /longy/gi）
							fileName = fileName.replace(/longyi/, '');
							console.log(this.$t('能源.处理后的文件名') + ':', fileName);
						}

						// 后续使用处理后的fileName
						const imageUrl = this.getImageUrl(fileName);
						this.formData.images.push({
							url: imageUrl,
							name: fileName, // 存储处理后的文件名
							uid: file.uid
						});
						console.log(this.formData.images);
						console.log(58963)
						// 5. 通知el-upload上传成功（更新UI状态）
						options.onSuccess(res, file);
						// this.$message.success('图片上传成功');
					} else {
						throw new Error(res.message || this.$t('路费.图片上传失败'));
					}
				}).catch(err => {
					// this.$message.error('接口请求失败');
					console.error(err);
				});

			},

			// 上传失败回调
			handleUploadError(err, file, fileList) {
				this.formData.images = fileList.filter(item => item.uid !== file.uid);
				this.$message.error(this.$t('路费.图片上传失败'));
			},

			//获取图片正式URL（基础路径 + 文件名）
			getImageUrl(fileName) {
				// 处理空值
				if (!fileName) return '';
				// 避免重复拼接（如果fileName已包含完整URL）
				return settings.baseUrl + fileName;
			},
			handleQuery() {
				this.currentPage = 1;
				this.getTableData();
			},
			onExportClick() {
				// 导出全部：PageNo=1, PageSize=65535
				let beginDate = '';
				let endDate = '';
				if (this.dateRange && this.dateRange.length === 2 && this.dateRange[0] && this.dateRange[1]) {
					beginDate = this.dateRange[0];
					endDate = this.dateRange[1];
				} else {
					const today = this.moment();
					beginDate = today.clone().subtract(6, 'days').format('YYYY-MM-DD');
					endDate = today.format('YYYY-MM-DD');
				}
				this.loading = true;
				this.$api.queryOilInfoNew({
					CarNo: this.searchKey,
					OilType: this.getOilType(),
					BeginDate: beginDate,
					EndDate: endDate,
					PageNo: 1,
					PageSize: 65535,
				}).then(res => {
					this.loading = false;
					if (!res || res.code != 200 || !res.data || res.data.length === 0) {
						this.$message.warning(this.$t('能源.no_data_export'));
						return;
					}
					const list = res.data.map(item => ({
						...item,
						operator: this.operator.OpeName
					}));
					this.exportToExcel(list);
					this.$message.success(this.$t('能源.export_success'));
				}).catch(() => {
					this.loading = false;
				});
			},
			exportToExcel(list) {
				const header = [
					this.$t('行程统计.车牌号'),
					this.$t('能源.操作日期'),
					this.getCostLabel().replace(':', ''),
					this.getVolumeLabel().replace(':', ''),
					this.getPriceLabel().replace(':', ''),
					this.getStationLabel().replace(':', ''),
					this.$t('能源.操作人员'),
					this.$t('路费.备注信息')
				];
				const rows = list.map(item => [
					item.CarNo || '',
					this.formatYmdDate(item, null),
					item.OilMoney != null ? item.OilMoney : '',
					item.OilNum != null ? item.OilNum : '',
					item.OilPrice != null ? item.OilPrice : '',
					item.OilStation || '',
					item.operator || '',
					item.Memo || ''
				]);
				const aoa = [header, ...rows];
				const ws = XLSX.utils.aoa_to_sheet(aoa);
				const wb = XLSX.utils.book_new();
				const sheetName = this.getAddButtonTitle();
				XLSX.utils.book_append_sheet(wb, ws, sheetName);
				const fileName = sheetName +
					this.moment(new Date()).format('YYYY-MM-DD') + '.xlsx';
				XLSX.writeFile(wb, fileName);
			},

			// 分页页码变更
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getTableData();
			},

			// 标签切换事件
			handleTabClick() {
				this.currentPage = 1;
				this.getTableData();
			},

			// 获取表格数据
			getTableData() {
				this.loading = true;
				let beginDate = '';
				let endDate = '';


				// 校验日期选择器是否有效（长度为2且有值）
				if (this.dateRange && this.dateRange.length === 2 && this.dateRange[0] && this.dateRange[1]) {
					beginDate = this.dateRange[0];
					endDate = this.dateRange[1];
				} else {
					// 🔴 核心修复：用clone()避免原地修改
					const today = moment();
					beginDate = today.clone().subtract(6, 'days').format('YYYY-MM-DD'); // 6天前
					endDate = today.format('YYYY-MM-DD'); // 今天
					this.dateRange = [beginDate, endDate]; // 同步更新日期选择器
				}

				// 调用接口，传入合法的日期参数
				this.$api.queryOilInfoNew({
					CarNo: this.searchKey,
					OilType: this.getOilType(),
					BeginDate: beginDate,
					EndDate: endDate,
					PageNo: this.currentPage,
					PageSize: this.pageSize,
				}).then(res => {
					this.loading = false; // 接口响应后关闭加载
					if (res.code === 200 && res.count > 0) {
						// this.tableData = res.data;
						this.tableData = (res.data).map(item => ({
							...item,
							operator: this.operator.OpeName
						}));
						this.total = res.count;
					} else {
						this.tableData = [];
						this.total = 0;
						// this.$message.error(this.$t('路费.数据加载失败') + ':' + (res.message || ''));
					}
				}).catch(err => {
					this.loading = false; // 接口异常时也关闭加载
					this.$message.error(this.$t('路费.接口请求失败'));
					console.error(err);
				});
			},
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.el-form-item__label {
			font-size: 12px;
		}

		.search-form .el-input__inner {
			width: 230px !important;
		}

		.el-date-editor .el-range-separator {
			width: 18% !important;
		}

		// 操作按钮样式优化
		.el-button--mini {
			padding: 4px 8px;
		}

		// 缩小上传组件尺寸
		.small-upload {
			.el-upload--picture-card {
				width: 80px !important;
				height: 80px !important;
				line-height: 80px !important;
			}

			// 缩小上传按钮图标
			.el-icon-plus {
				font-size: 20px !important;
			}

			// 缩小已上传图片的尺寸
			.el-upload-list__item {
				width: 80px !important;
				height: 80px !important;
			}
		}

		// 表格图片预览样式
		.el-image {
			border-radius: 4px;
		}
	}

	/* 图片组样式：横向排列，超出部分自动隐藏（可选） */
	.image-group {
		display: inline-flex;
		align-items: center;
		flex-wrap: nowrap;
		max-width: 100%;
		overflow: hidden;
	}

	/* 确保表格单元格内容不换行 */
	::v-deep .el-table .cell {
		white-space: nowrap;
	}

	::v-deep .search-key-input .el-input__inner {
		width: 150px !important;
	}
	.pagination .el-input__inner {
		width: auto !important;
	}
</style>